.otherInput {
  margin-top: var(--spacingMd);
}
